//wordpress dependencies
const { __ } = wp.i18n;
const { useState, useEffect, useRef, Component, createRef } = wp.element;
import { Spinner } from "@wordpress/components";
import axios from "axios";
import Qs from "qs";
import "./editor.scss";
import "./style.scss";
import Inspector from "./inspector";
import RenderView from "./renderView";
import classnames from "classnames";
import { CssGenerator } from "../../util/css/CssGenerator";

function Edit(props) {
	const { isSelected, attributes, setAttributes, className, clientId } = props;

	const { blockId } = attributes;
	const _client = clientId.substr(0, 6);
	useEffect(() => {
		if (!blockId) {
			setAttributes({ blockId: _client });
		} else if (blockId && blockId !== _client) {
			setAttributes({ blockId: _client });
		}
	}, []);



	if (blockId) {
		CssGenerator(attributes, 'pricing-table', blockId);
	}

	const MainWrapperClass = classnames([
		'rtcl-block-' + blockId,
		className,
		'rtcl-block-editor'
	]);

	//render
	return [
		isSelected && (
			<Inspector
				attributes={attributes}
				setAttributes={setAttributes}
			/>
		),

		<div className={MainWrapperClass}>
			<RenderView {...attributes} data={'hh'} />
		</div>
	]
}

export default Edit;